export const REACT_APP_SENTRY_DSN = 'REACT_APP_SENTRY_DSN_PLACEHOLDER';
export const REACT_APP_SENTRY_ENVIRONMENT = 'REACT_APP_SENTRY_ENVIRONMENT_PLACEHOLDER';
export const REACT_APP_STRIPE_PUBLIC_KEY = 'REACT_APP_STRIPE_PUBLIC_KEY_PLACEHOLDER';
export const REACT_APP_APOLLO_GRAPHQL_WEBSOCKET_URL = 'REACT_APP_APOLLO_GRAPHQL_WEBSOCKET_URL_PLACEHOLDER';
export const REACT_APP_APOLLO_GRAPHQL_URL = 'REACT_APP_APOLLO_GRAPHQL_URL_PLACEHOLDER';
export const REACT_APP_AUTH0_HOST = 'REACT_APP_AUTH0_HOST_PLACEHOLDER';
export const REACT_APP_AUTH0_MERCHANT_CLIENT_ID = 'REACT_APP_AUTH0_MERCHANT_CLIENT_ID_PLACEHOLDER';
export const REACT_APP_WEBHOOKS_BASE_URL = 'REACT_APP_WEBHOOKS_BASE_URL_PLACEHOLDER';
export const REACT_APP_FRONTEND_URL = 'REACT_APP_FRONTEND_URL_PLACEHOLDER';
export const REACT_APP_FIREBASE_API_KEY = 'REACT_APP_FIREBASE_API_KEY_PLACEHOLDER';
export const REACT_APP_FIREBASE_AUTH_DOMAIN = 'REACT_APP_FIREBASE_AUTH_DOMAIN_PLACEHOLDER';
export const REACT_APP_FIREBASE_PROJECT_ID = 'REACT_APP_FIREBASE_PROJECT_ID_PLACEHOLDER';
export const REACT_APP_FIREBASE_STORAGE_BUCKET = 'REACT_APP_FIREBASE_STORAGE_BUCKET_PLACEHOLDER';
export const REACT_APP_FIREBASE_MESSAGING_SENDER_ID = 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PLACEHOLDER';
export const REACT_APP_FIREBASE_APP_ID = 'REACT_APP_FIREBASE_APP_ID_PLACEHOLDER';
export const REACT_APP_FIREBASE_MEASUREMENT_ID = 'REACT_APP_FIREBASE_MEASUREMENT_ID_PLACEHOLDER';
